import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";

const NotFound = () => {
  const [timeLeft, setTimeLeft] = useState(15); // 10 seconds
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000); // execute every second

    return () => clearTimeout(timer);
  }, [timeLeft]);

  useEffect(() => {
    if (timeLeft === 0) {
      navigate("/");
    }
    document.title = "Page Not Found | Aneeq Ullah Khan";
  }, [timeLeft, navigate]);

  return (
    <div>
      <Navbar />
      <div className="container mt-5 mb-5">
        <h2 className="section-text text-center">Page Not Found</h2>
        <p className="container text-center">
          If you mistakenly open the wrong page or any page is not accessible so
          I am sorry for this issue soon I will fix this issue for now I'm
          returning you to the home page in {timeLeft}s.
        </p>
        <div className="text-center">
          <Link to="/">
            <button className="btn-login">Retun Back</button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
